import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CustomerService} from '../data/customer.service';
import {JoinDuplicateCustomersService} from '../data/joinDuplicate.service';
import {Subscription} from 'rxjs';
import {JBMTableColumnDef, JBMTableColumnType} from '../../../components/JBM/JBMTable/JBMTable.component';
import {FilterOperator, QueryHttpHelper, SearchColumnType} from '../../../components/JBM/Helpers/QueryHttpHelper';

@Component({
  selector: 'join-duplicate',
  templateUrl: './join-duplicate.component.html',
  styleUrls: ['./join-duplicate.component.scss']
})

export class JoinDuplicateComponent implements OnInit, OnDestroy {
  customers$: Subscription;
  count$: Subscription;

  customers: any[];
  duplicate_id: number=-1
  columnDefs: JBMTableColumnDef[];
  queryHttpHelper: QueryHttpHelper;

  @Input() customerId: number;
  @Input() customerName: string=''

  @Output() onClose=new EventEmitter();
  @Output() onJoined=new EventEmitter();

  constructor(
      private CustomerService: CustomerService,
      private JoinDuplicateCustomersService: JoinDuplicateCustomersService,
  ) {
    this.queryHttpHelper = new QueryHttpHelper();
    this.queryHttpHelper.setSortColumn('name');
    this.queryHttpHelper.addSearchColumn('name', SearchColumnType.string);
    this.queryHttpHelper.paginationProps.pageSize=5

    this.columnDefs = [
      { name: 'id', type: JBMTableColumnType.id },
      { name: 'name', header: '' }
    ]
  }

  ngOnInit(): void {
    this.queryHttpHelper.setFilterItem('id', this.customerId, FilterOperator.noteq)
    this.getData(true)
  }
  getData(countRows: boolean=false) {
    this.duplicate_id=-1; // reset selection

    let params=this.queryHttpHelper.getHttpParams(false);
    this.customers$ = this.CustomerService.getData(params).subscribe(
        (data: any)=> {
          this.customers = data.data
          if(!countRows)
            return;

          params=this.queryHttpHelper.getHttpParams(true);
          this.count$ = this.CustomerService.getData(params).subscribe(
              (data: any)=>this.queryHttpHelper.paginationProps.itemCount=data.data,
              (error)=>console.log(error))
        },
        (error)=>console.error(error), ()=> {} );
  }
  // Event handling
  pageChange(page) {
    this.queryHttpHelper.paginationProps.page = page;
    this.getData();
  }
  searchChange(event) {
    let value = event.value;
    const minlength = event.minlength;
    value = value.length < minlength ? '' : value;
    if (this.queryHttpHelper.getSearchValue() !== value) {
      this.queryHttpHelper.setSearchValue(value);
      this.getData(true);
    }
  }
  selectDuplicate(event: any) {
    this.duplicate_id=event.id
  }
  join() {
    this.JoinDuplicateCustomersService.joinDuplicate(this.customerId, this.duplicate_id).subscribe(
        ()=>this.onJoined.emit(), (error)=>console.error(error), ()=> {})
  }
  close() {
    this.onClose.emit();
  }
  ngOnDestroy(): void {
    // Clean up observable subscriptions to avoid memory leaks
    if(this.customers$ !== undefined) { this.customers$.unsubscribe(); }
    if(this.count$ !== undefined) { this.count$.unsubscribe(); }
  }
}
